/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_SettingsInputs */



/**
* | output |
* | --- |
* | "Zoom Settings" |
*
* @param {Zoom_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_settings = /** @type {((inputs?: Zoom_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de zoom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoom-Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni dello zoom")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки масштабирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩放设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズーム設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de zoom")
	return /** @type {LocalizedString} */ ("Zoom Settings")
});